import { useEffect, useState } from 'react'
import Scoreboard from './Scoreboard'
import type { ScoreboardItems } from './Scoreboard'


export default function ScoreboardProvider ({ uiEnabled = true }: { uiEnabled?: boolean }) {
  const [title, setTitle] = useState('Scoreboard')
  const [items, setItems] = useState<ScoreboardItems>([])
  const [open, setOpen] = useState(false)

  useEffect(() => {
    const updateSidebarScoreboard = () => {
      addStatPerSec('scoreboard')
      if (bot.scoreboard.sidebar) {
        setTitle(bot.scoreboard.sidebar.title)
        setItems([...bot.scoreboard.sidebar.items])
        setOpen(true)
      } else {
        setOpen(false)
      }
    }

    const off = (bot as any).off?.bind(bot) ?? bot.removeListener.bind(bot)

    bot.on('scoreboardCreated', updateSidebarScoreboard)
    bot.on('scoreboardTitleChanged', updateSidebarScoreboard)
    bot.on('scoreUpdated', updateSidebarScoreboard)
    bot.on('scoreRemoved', updateSidebarScoreboard)
    bot.on('scoreboardDeleted', updateSidebarScoreboard)

    const onPosition = () => {
      void Promise.resolve().then(() => {
        updateSidebarScoreboard()
      })
    }
    bot.on('scoreboardPosition', onPosition)

    updateSidebarScoreboard()
    return () => {
      off('scoreboardCreated', updateSidebarScoreboard)
      off('scoreboardTitleChanged', updateSidebarScoreboard)
      off('scoreUpdated', updateSidebarScoreboard)
      off('scoreRemoved', updateSidebarScoreboard)
      off('scoreboardDeleted', updateSidebarScoreboard)
      off('scoreboardPosition', onPosition)
    }
  }, [])

  return (
    <Scoreboard
      title={title}
      items={items}
      open={open && uiEnabled}
    />
  )
}
